import { motion } from "framer-motion";

const CHAPTERS = [
  {
    n: "01",
    title: "THE DROP",
    body: "Δέκα σχέδια, μια συλλογή. Κάθε drop ξεκινά από μια ιδέα και τελειώνει με βαμβακερό ύφασμα. Χωρίς stock, χωρίς φιλτραρίσματα — απλά αυθεντικό streetwear.",
  },
  {
    n: "02",
    title: "THE ART",
    body: "Δουλεύουμε κάθε σχέδιο βήμα-βήμα: ιδέα, σκίτσο, χρώμα, τύπωμα. Το αποτέλεσμα είναι γραφικά που δεν θα βρεις πουθενά αλλού.",
  },
  {
    n: "03",
    title: "THE VIBE",
    body: "Πέντε χρώματα υφάσματος. Πέντε ταυτότητες. Μαύρο, άσπρο, κίτρινο, μπεζ, πράσινο. Διάλεξε τη διάθεση σου και φόρα την — κανείς κώδικας ντυσίματος.",
  },
  {
    n: "04",
    title: "THE ORDER",
    body: "Καμία περίπλοκη διαδικασία. Επιλέγεις σχέδιο, χρώμα, ποσότητα και πατάς “Παραγγελία”. Η αίτησή σου φτάνει κατευθείαν στο inbox μας — απαντάμε άμεσα.",
  },
];

export default function Manifesto() {
  return (
    <section
      id="manifesto"
      className="relative px-4 md:px-8 lg:px-12 py-24 md:py-40 border-t border-[var(--ink)]"
    >
      <div className="flex items-baseline justify-between mb-14 md:mb-24">
        <span className="font-mono-caps text-xs">§ 02 — MANIFESTO</span>
        <span className="font-mono-caps text-xs">2025 / 04 CHAPTERS</span>
      </div>

      <motion.h2
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
        className="font-display text-5xl md:text-7xl lg:text-[9vw] leading-[0.9] mb-16 md:mb-28 max-w-6xl"
      >
        ΤΙ ΦΤΙΑΧΝΟΥΜΕ<span className="text-[var(--lime)] bg-[var(--ink)] px-2 mx-1">&amp;</span>
        <span className="text-outline block md:inline"> ΓΙΑΤΙ.</span>
      </motion.h2>

      <div className="grid grid-cols-1 md:grid-cols-12 gap-y-16 md:gap-x-8">
        {CHAPTERS.map((c, i) => (
          <motion.div
            key={c.n}
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ delay: i * 0.08, duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
            className={
              "md:col-span-6 lg:col-span-6 " +
              (i % 2 === 1 ? "md:pl-16 lg:pl-32" : "")
            }
          >
            <div className="flex items-start gap-6 md:gap-10">
              <div className="font-display text-6xl md:text-8xl text-outline leading-none shrink-0">
                {c.n}
              </div>
              <div>
                <h3 className="font-display text-2xl md:text-3xl mb-3">
                  {c.title}
                </h3>
                <p className="text-base md:text-lg leading-relaxed max-w-md text-[var(--ink-70)]">
                  {c.body}
                </p>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
